import { CustomButton } from './component';

export type { ButtonProps } from './types';
export { CustomButton };
export default CustomButton;
